/* COMBÍNALO CON ELEGANCIA (carrito): comportamiento de las tarjetas (color -> foto, talla/color -> variante, aviso en "Añadir", flechas).
   Se carga SIEMPRE desde snippets/skip-to-content-link.liquid (se renderiza en todas las páginas), porque el HTML del cajón del carrito llega a veces por morph (carrito vacío -> con productos) y los <script> de ese HTML no se ejecutan. */
(function () {
  if (window.__vnCompInit) return;
  window.__vnCompInit = true;

  function cardState(card) {
    var selects = card.querySelectorAll('[data-vn-comp-select]');
    var missing = null;
    Array.prototype.forEach.call(selects, function (s) {
      if (!s.value && !missing) missing = s;
    });
    var match = null;
    if (!missing) {
      var variants = [];
      try {
        variants = JSON.parse(card.getAttribute('data-variants') || '[]');
      } catch (e) {}
      match = variants.filter(function (v) {
        return Array.prototype.every.call(selects, function (s) {
          return v.o[Number(s.getAttribute('data-index'))] === s.value;
        });
      })[0];
    }
    return { missing: missing, match: match, ok: !!(match && match.a) };
  }

  function showMsg(card, text) {
    var msg = card.querySelector('[data-vn-comp-msg]');
    if (!msg) return;
    msg.textContent = text || '';
    msg.hidden = !text;
  }

  function onSelect(event) {
    var select = event.target && event.target.closest && event.target.closest('[data-vn-comp-select]');
    if (!select) return;
    var card = select.closest('[data-vn-comp-card]');
    if (!card) return;

    if (select.getAttribute('data-kind') === 'color') {
      var images = {};
      try {
        images = JSON.parse(card.getAttribute('data-images') || '{}');
      } catch (e) {}
      var url = images[select.value];
      var img = card.querySelector('.vn-comp__img');
      if (url && img) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = url;
      }
    }

    var state = cardState(card);
    var input = card.querySelector('input[name="id"]');
    if (input) input.value = state.ok ? String(state.match.id) : '';
    if (!state.missing && !state.ok) {
      showMsg(card, 'Esta combinación no está disponible');
    } else {
      showMsg(card, '');
    }
  }
  document.addEventListener('change', onSelect);
  document.addEventListener('input', onSelect);

  /* El boton siempre parece activo: si falta elegir talla/color (o la combinacion no existe) se avisa en vez de añadir. */
  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target && event.target.closest && event.target.closest('.vn-comp__btn');
      if (!btn) return;
      var card = btn.closest('[data-vn-comp-card]');
      if (!card || !card.hasAttribute('data-variants')) return;
      var state = cardState(card);
      if (state.ok) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (state.missing) {
        showMsg(card, 'Elige tu ' + (state.missing.getAttribute('data-label') || 'opción'));
        state.missing.focus();
      } else {
        showMsg(card, 'Esta combinación no está disponible');
      }
    },
    true
  );

  function updateArrows(track) {
    var viewport = track.parentElement;
    if (!viewport || !track.clientWidth) return;
    var prev = viewport.querySelector('.vn-comp__arrow--prev');
    var next = viewport.querySelector('.vn-comp__arrow--next');
    var max = track.scrollWidth - track.clientWidth;
    if (prev) prev.hidden = track.scrollLeft <= 2;
    if (next) next.hidden = max <= 2 || track.scrollLeft >= max - 2;
  }

  function updateAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.vn-comp__track'), updateArrows);
  }

  document.addEventListener(
    'scroll',
    function (event) {
      if (event.target && event.target.classList && event.target.classList.contains('vn-comp__track')) {
        updateArrows(event.target);
      }
    },
    true
  );

  document.addEventListener('click', function (event) {
    var arrow = event.target && event.target.closest && event.target.closest('[data-vn-comp-arrow]');
    if (!arrow) return;
    var track = arrow.parentElement.querySelector('.vn-comp__track');
    if (!track) return;
    var card = track.querySelector('.vn-comp__card');
    var step = card ? (card.offsetWidth + 12) * 2 : track.clientWidth * 0.8;
    track.scrollBy({ left: Number(arrow.getAttribute('data-vn-comp-arrow')) * step, behavior: 'smooth' });
  });

  var timer;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(updateAll, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('resize', updateAll);
  updateAll();
})();
